import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ScreeningService } from '../services/screening.service';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.less']
})
export class LandingPageComponent implements OnInit, AfterViewInit {

  userId : number;
  clientlocation : number;
  callForInvite : Subject<string> = new Subject<string>();
  sub : Subscription;
  constructor(public location : Router, public activatedRoute: ActivatedRoute, public screeningSrv : ScreeningService, public auth : AuthService, public cook : CookieService){
    // this.callForInvite.subscribe(s =>{
    //   screeningSrv.getInvite(s);
    // })
  }
  title = 'stp-screening';
  continue() : void {
    console.log('navigating');
    //this.sub.unsubscribe();
    
 
     this.location.navigateByUrl('/pw-set');
  }
  ngOnInit() {
    this.sub = this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.screeningSrv.screeningToken = params.get('token');
        this.screeningSrv.screeningType = params.get('type');
        this.auth.titleBarText = this.screeningSrv.screeningType == 'user' ? 'New User Setup' :`${this.screeningSrv.screeningType} Screening`;
        this.screeningSrv.getInvite();
        // TODO: if there is already a screening for this invitation then prompt the user for their password:
          // if they have not finished the screening then take them to the demographics page.
          // else send them to applicant review.
      });
  }

  ngAfterViewInit(){
    
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }

}
